import React from "react";
import "../../../App.css";
import { Link } from "react-router-dom";
import "./BecomeAgent.css";
import DefaultLayout from "../../.././layouts/DefaultLayout";
import TelegramCommunity from "../TelegramCommunity";
import rectangle188 from "../../Assets/Rectangle 188.svg";
import rectangle189 from "../../Assets/Rectangle 189.svg";
import rectangle190 from "../../Assets/Rectangle 190.svg";
import rectangle191 from "../../Assets/Rectangle 191.svg";
import BenefitOfAgent from "./BenefitsOfAgent";
import GetStarted from "./GetStarted";
import orangeblob from "../../Assets/orangeblob.svg";
import blueblob from "../../Assets/blueblob.svg";
import purpleblob from "../../Assets/purpleblob.svg";
import greenblob from "../../Assets/greenblob.svg";

const BecomeAgent = () => {
  return (
    <>
      <DefaultLayout>
        <div className="become-an-agent">
          <div className="become-an-agent-container">
            <div className="become-an-agent-main">
              <div className="become-an-agent-header">
                <h5 className="become-an-agent-h5">
                  We'd Love to Have You as an Agent
                </h5>
                <img src={greenblob} alt="green-blob" className="green-blob" />
              </div>
              <p className="become-an-agent-p">
                iRepOVest is a community of driven individuals who earn by
                telling more people about OVest. We pay partners who are able to
                reach goals, a salary monthly.
              </p>
              <div className="agent-button-container">
                <img
                  src={purpleblob}
                  alt="purple-blob"
                  className="purple-blob"
                />
                {/* <Link to="/signup">
                  <button className="register-as-an-agent">Register</button>
                </Link> */}
              </div>
              <div className="become-an-agent-images">
                <img src={blueblob} alt="" className="darkblue-blob" />
                <div className="landingpage-img1">
                  <img src={rectangle188} alt="landing-page-img" />
                </div>
                <div className="">
                  <img
                    src={rectangle189}
                    alt="landing-page-img"
                    className="landingpage-img2"
                  />
                  <img
                    src={rectangle190}
                    alt="landing-page-img"
                    className="mt-3 landingpage-img3"
                  />
                </div>
                <div className="landingpage-img4">
                  <img src={rectangle191} alt="landing-page-img mr-5" />
                  <img src={orangeblob} alt="" className="orange-blob" />
                </div>
              </div>
            </div>
          </div>
          <div>
            <BenefitOfAgent />
          </div>
          <div>
            <GetStarted />
          </div>
          <div className="">
            <TelegramCommunity />
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};
export default BecomeAgent;
